import { lazy, useEffect } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { OrderDraftItemBackgroundUpdateStatusContextProvider } from '../hooks/useOrderDraftItemBackgroundUpdateStatusContext'
import { OrderDraftItemMutationStatusContextProvider } from '../hooks/useOrderDraftItemMutationStatusContext'
import { OrderDraftMutationStatusContextProvider } from '../hooks/useOrderDraftMutationStatusContext'

const OrderRequestViewChunk = lazy(() =>
  import('../feature-sets/OrderRequestView').then(({ OrderRequestView }) => ({
    default: OrderRequestView,
  }))
)

export const OrderRequestPage = () => {
  const intl = useProcurifyIntl()

  useEffect(() => {
    window.analytics?.page('Next Gen Intake', { flow: 'nextgen' })
  }, [])

  return (
    <Page
      pageTitle={intl.formatMessage(messages.createOrderRequestPageTitle)}
      breadcrumbs={[]}
    >
      <OrderDraftMutationStatusContextProvider>
        <OrderDraftItemMutationStatusContextProvider>
          <OrderDraftItemBackgroundUpdateStatusContextProvider>
            <OrderRequestViewChunk />
          </OrderDraftItemBackgroundUpdateStatusContextProvider>
        </OrderDraftItemMutationStatusContextProvider>
      </OrderDraftMutationStatusContextProvider>
    </Page>
  )
}
